module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/portrait/small/avatar-s-25.jpg";